import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { BaseService } from './base/base.service';
import { Observable } from 'rxjs';
import { Eula } from '../../model/eula';
import { CreditCard } from '../../model/credit.card';
import { CardSession } from '../../model/card.session';
import { AddCardResult } from '../../model/add.card.result';

@Injectable({
  providedIn: 'root'
})
export class CardService extends BaseService {

  resourceUrl = 'card';

  //Çerçeve Sözleşmesi ve Kart Sözleşmesini Getiren Method
  getEula(trackingId: string): Observable<Eula> {
    return this.get(`eula/${trackingId}`);
  }

  //Threed ile Kart Ekleme Öncesinde ThreedSession Oluşturan Method.
  createThreeDSession(card: CreditCard, trackingId: string): Observable<CardSession> {
    return this.post(`createThreeDSession/${trackingId}`, card);
  }

  //Threed ekranı verdiğimiz callback url'i çağırınca gerekli component üzerinden threed ile kart ekleme servisi çağrılır.
  addThreeD(card: CardSession, trackingId: string): Observable<AddCardResult> {
    return this.post(`addThreeD/${trackingId}`, card);
  }

  //Kart Ekleme Servisi.
  addCard(card: CreditCard, trackingId: string): Observable<AddCardResult> {
    return this.post(`add/${trackingId}`, card);
  }

  getHttpParams(): HttpParams {
    return undefined;
  }

  getPath(): string {
    return this.resourceUrl;
  }
}
